import { useEffect } from 'react';

export const useSetPageTitle = ({
  isActive,
  name,
}: {
  isActive: boolean;
  name: string;
}) => {
  useEffect(() => {
    const title = document.title;
    if (isActive && name) {
      document.title = `${name} - ${title}`;
      return () => {
        document.title = title;
      };
    }
  }, [isActive, name]);
};
